import React, { useEffect, useState } from 'react';
import {Divider, Table, Input, Select, ConfigProvider} from 'antd';

import type { RadioChangeEvent, TableColumnsType } from 'antd';
import { DataType, TITLES } from '../types/GridTypes';
import { clientFlights, competitorsFlights } from '../assets/data';
import {
  DownCircleFilled,
  MinusCircleFilled,
  UpCircleFilled,
} from '@ant-design/icons';
import FilterOptions from './components/FilterOptions';
import {
  AirportColumns,
  DestCityColumns,
  DestCountryColumns,
  FlightColumns,
} from './Columns';
import { calculatePrices } from '../utils/calculatePrices';
import '../styles/Pagination.css';
import ColumnDnd from './components/ColumnsDnd';
import { aggregationChanged } from '../utils/aggregationHandlers';
import SaveDownloadGroup from "./SaveDownloadGroup";
import {FILTER_OPERATOR, FILTER_TO_TITLES, intialFilters} from "./components/FilterModalConsts";
import {FiltersHandlers} from "../utils/FiltersHandlers";
import axios from "axios";
import {DEFAULT_URL} from "../constants";
import {downloadCSV, getReportName} from "../utils/GridUtils";
import { useLocation } from 'react-router-dom';


const calculationFilter = {
  Date: false,
  ArrivalType: false,
  Destination: false,
  Airport: true,
};

let relevantClientFlights = clientFlights;
let relevantCompetitorsFlights = competitorsFlights;

const defaultCheckedList = (col: any[]) =>
  col.map((item) => {
    return item.key as string;
  });
type ReportMeta = {
  Tab?: string,
  Section?: string,
  ReportName?: string,
};

const Grid: (reportMetadata?: ReportMeta) => JSX.Element = (reportMetadata?:ReportMeta) => {
  const location = useLocation();
  const [filters, setFilters] = useState(intialFilters);

  if(!reportMetadata?.['ReportName']) {
    reportMetadata = location.state;
  }
useEffect(() => {

  const fetchReports = async () => {
    if(!(reportMetadata?.Tab && reportMetadata?.ReportName && reportMetadata?.Section)){
      return;
    }
    try {

      const response = await axios({
        method: 'get',
        url: `${DEFAULT_URL}saved_reports`,
        params: {
          report_tab: reportMetadata?.Tab,
          section: reportMetadata?.Section || null,
          report_name: reportMetadata?.ReportName,
        },
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      });
      const data: any[] = []
      if(!response.data) {
        return;
      }
      response.data.forEach((report: any) => {
        data.push(report);
      })

      aggregationChanged(response?.data?.[0]?.['aggregation'] as string,
          setReportTitle,
          setAggregatedClientFlights,
          setAggregatedCompetitorsFlights,
          setColums,
          setData,
          setCheckedList,
          setSelectedColumns,
          clientFlights,
          competitorsFlights,
          FlightColumns,
          AirportColumns,
          DestCityColumns,
          DestCountryColumns,
          defaultCheckedList,
          SetPlacement,
          relevantCompetitorsFlights,
          relevantClientFlights,);
      const filters = JSON.parse(response?.data?.[0]?.['filters'] && response?.data?.[0]?.['filters']);
      if(filters) {
        setFilters(filters);
      }
      if (reportMetadata?.ReportName) {
        const reportName = getReportName(reportMetadata.ReportName);
        setReportTitle(reportName);
      }
    } catch (error) {
      console.error('Failed to fetch reports:', error);
    }
  };
  if(reportMetadata?.['Section']) {
  fetchReports();
  }
}, []);
  const [aggregatedClientFlights, setAggregatedClientFlights] = useState<any[]>(
    relevantClientFlights,
  );
  useEffect(() => {
    handleOk(filters)
  },[aggregatedClientFlights, filters]);

  const [aggregatedCompetitorsFlights, setAggregatedCompetitorsFlights] =
    useState<any[]>(competitorsFlights);

  const [calculationFilters, setCalculationFilters] =
    useState<any>(calculationFilter);

  const [columns, setColums] =
    useState<TableColumnsType<DataType>>(FlightColumns);


  const [checkedList, setCheckedList] = useState(defaultCheckedList(columns));
  const [reportTitle, setReportTitle] = useState(
    'Competitive snapshot by flight',
  );
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [placement, SetPlacement] = useState<string>('flight');
  const [selectedColumns, setSelectedColumns] = useState(
    columns
      .map((item) => {
        if (!item.hidden) {
          return item.key as string;
        } else return '-1';
      })
      .filter((item) => item !== '-1'),
  );


  const getData = (relevantClientFlights: any[], calculationFilters: any, optionalFilters?: any) =>{

    const calculatedFlights = relevantClientFlights.map((clientFlight, index) => {
      clientFlight['key'] = index as React.Key;
      const prices: any = calculatePrices(
          clientFlight,
          calculationFilters,
          relevantCompetitorsFlights,
      );
      clientFlight[TITLES.PRICE_VS_MARKET] = `${prices[TITLES.PRICE_VS_MARKET][1]}%`;
      clientFlight[TITLES.PRICE_VS_BRITISH_AIRWAYS] =
          `${prices[TITLES.PRICE_VS_BRITISH_AIRWAYS][1]}%`;
      clientFlight[TITLES.PRICE_VS_BLUE_AIR] =
          `${prices[TITLES.PRICE_VS_BLUE_AIR][1]}%`;
      clientFlight[TITLES.PRICE_VS_WIZZ_AIR] =
          `${prices[TITLES.PRICE_VS_WIZZ_AIR][1]}%`;
      clientFlight[TITLES.PRICE_VS_RYANAIR] =
          `${prices[TITLES.PRICE_VS_RYANAIR][1]}%`;
      clientFlight[TITLES.PRICE_VS_EASY_JET] =
          `${prices[TITLES.PRICE_VS_EASY_JET][1]}%`;

      clientFlight[TITLES.MARKET_PRICE_AVG] =
            prices[TITLES.PRICE_VS_MARKET][0];
      clientFlight[TITLES.BRITIS_AIRWAYS_PRICE_AVG] =
            prices[TITLES.PRICE_VS_BRITISH_AIRWAYS][0];
      clientFlight[TITLES.BLUE_AIR_PRICE_AVG] =
            prices[TITLES.PRICE_VS_BLUE_AIR][0];
      clientFlight[TITLES.WIZZ_AIR_PRICE_AVG] =
            prices[TITLES.PRICE_VS_WIZZ_AIR][0];
        clientFlight[TITLES.RYANAIR_PRICE_AVG] =
            prices[TITLES.PRICE_VS_RYANAIR][0];
        clientFlight[TITLES.EASY_JET_PRICE_AVG] =
            prices[TITLES.PRICE_VS_EASY_JET][0];

        clientFlight[TITLES.PRICE_DIFFERENCE] = prices[TITLES.PRICE_DIFFERENCE];
      return clientFlight as DataType;
    })

    return applyFilters(calculatedFlights, optionalFilters);
    }
  const applyFilters = (data: any[], optionalFilters?:{}) => {
    const actualFilters = optionalFilters || filters;
    let filteredData = [...data];
    if(!actualFilters) {
      return filteredData;
    }
    for (const filterFamily in filters) {
      // @ts-ignore
      actualFilters[filterFamily].forEach((filter:any) => {
        filteredData = filteredData.filter((item) => {
          if(!(filter.value || filter.value === false)) {
            return true
          }
          if(filter.isSpecial) {
            return FiltersHandlers.handleSpecialCases(filter, item);
          }
            switch (filter.operator) {
              case FILTER_OPERATOR.STRING:
                // @ts-ignore
                return filter.value ? item[FILTER_TO_TITLES[filter?.field]] === filter.value : true;
              case FILTER_OPERATOR.NUMBER:
                return FiltersHandlers.handleNumberFilters(filter, item);
              case FILTER_OPERATOR.BOOLEAN:
                return filter.value
                    ? Boolean(item[filter.field]) === Boolean(filter.value)
                    : true;
              case FILTER_OPERATOR.DATE:
                return filter.value
                    ? new Date(item[filter.field]) >= new Date(filter.value)
                    : true;
              case FILTER_OPERATOR.SELECT:
                // @ts-ignore
                return filter.value ? item[FILTER_TO_TITLES[filter?.field]] === filter.value : true;

              default:
                return true;
            }

        });
      });
    }

    return filteredData;
  };

  const [data, setData] = useState<DataType[]>(
      getData(aggregatedClientFlights, calculationFilters),
  );

  const { Option, OptGroup } = Select;

  const downloadCsv =() => {downloadCSV(data)}
  const aggregationChange = (e: RadioChangeEvent) => {
    aggregationChanged(
      e.target.value,
      setReportTitle,
      setAggregatedClientFlights,
      setAggregatedCompetitorsFlights,
      setColums,
      setData,
      setCheckedList,
      setSelectedColumns,
      clientFlights,
      competitorsFlights,
      FlightColumns,
      AirportColumns,
      DestCityColumns,
      DestCountryColumns,
      defaultCheckedList,
      SetPlacement,
      relevantCompetitorsFlights,
      relevantClientFlights,
    );
  };


  const changeColomnsHandler = (columns: any[]) => {
    setColums(columns);
    setData(relevantClientFlights);
  };

  const handleOk = (filters:any) => {
    setIsModalVisible(false);
    setFilters(filters);
    setTimeout(() => {
      setData(getData(aggregatedClientFlights, calculationFilters, filters));
    }
  , 100);
    }

  const onSearch = (value: string) => {
    const filteredData = relevantClientFlights.filter((flight) => {
      return Object.values(flight).some((val: any) => {
        return val.toString().toLowerCase().includes(value.toLowerCase());
      });
    });
  };

  const newColumns = columns.map((item) => ({
    ...item,
    hidden: !checkedList.includes(item.key as string),
  }));
  const handleSelectChange = (value: string[]) => {
    setSelectedColumns(value);
  };
  const { Search } = Input;

  return (
      <>
          <Divider style={{marginBottom:0}}>
              <h3 style={{ fontSize: '30px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: 'rgb(8 59 123)', letterSpacing: '0.5px' }}>{reportTitle}</h3>
          </Divider>
          <SaveDownloadGroup placement={placement}  checkedList={checkedList} calculationFilter={calculationFilter} filters={filters} downloadCsv={downloadCsv} setFilters = {setFilters}/>
        <FilterOptions
            placement={placement}
            placementChange={aggregationChange}
            handleOk={handleOk}
            setCalculationFilters={setCalculationFilters}
            calculationFilters={calculationFilters}
            filters={filters}
        />
        <div
            style={{
              display: 'flex',
              marginBottom: 1,
              border: 'solid lightgray 1px',
              padding: '5px',
            }}
        >
          <div style={{width: '40%', marginRight: 'auto'}}>
            <Search
                placeholder="Search in report"
                allowClear
                onSearch={onSearch}
                style={{width: 200, marginRight: '2%'}}
            />
            <ColumnDnd
                columns={newColumns}
                changeColomnsHandler={changeColomnsHandler}
            />
          </div>
          <div style={{width: '45%', textAlign: 'left'}}>
            <DownCircleFilled style={{fontSize: '24px', color: '#28a745'}}/> -
            I am lower
            <MinusCircleFilled
                style={{fontSize: '24px', color: '#18a2b8', marginLeft: '1%'}}
            />{' '}
            - I am equal
            <UpCircleFilled
                style={{fontSize: '24px', color: '#ffc108', marginLeft: '1%'}}
            />{' '}
            - I am higher
          </div>
          <div style={{width: '30%', textAlign: 'right'}}>
            <Select
                style={{width: '35%', marginRight: '5%'}}
                placeholder="Flight "
                value={'Economy'}
                maxTagCount={0}
            >
              <Option key={'Economy'} value={'Economy'}>
                {'Economy'}
              </Option>
              <Option key={'Business'} value={'Business'}>
                {'Business'}
              </Option>
              <Option key={'First'} value={'First'}>
                {'First'}
              </Option>
            </Select>
            <Select
                mode="multiple"
                style={{width: '50%'}}
                placeholder="Select columns"
                value={selectedColumns}
                onChange={handleSelectChange}
                dropdownStyle={{width: '40%'}}
                maxTagCount={0}
                maxTagPlaceholder={`Column Selection`}
            >
              <OptGroup label="Flight Details">
                {columns
                    .filter((column) => parseInt(column.key as string) <= 15)
                    .map(({key, title}) => (
                        <Option key={key as string} value={key as string}>
                          {title as string}
                        </Option>
                    ))}
              </OptGroup>
              <OptGroup label="Pricing Information">
                {columns
                    .filter((column) => parseInt(column.key as string) > 15)
                    .map(({key, title}) => (
                        <Option key={key as string} value={key as string}>
                          {title as string}
                        </Option>
                    ))}
              </OptGroup>
            </Select>
          </div>
        </div>
        <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: '#efe5d39c',
                },
                Pagination: {
                  itemBg: '#daf0f7',
                },
              },
            }}
        >
          <Table
              columns={newColumns.filter((column) =>
                  selectedColumns.includes(column.key as string),
              )}
              dataSource={data}
              pagination={{
                position: ['topLeft'],
                showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`,
                pageSize: 20,
              }}
              scroll={{x: 2500, y: 500}}
              bordered={true}
          />
        </ConfigProvider>
      </>
  );
};

export default Grid;
